import React, { useState, useRef } from "react"
import { Image, Box, Flex, Text } from "rebass"
import { Link } from "gatsby"
import propTypes from "prop-types"
import styled from "styled-components"

import withTranslation from "../i18n/withTranslation"
import Contact from "./Contact"

import logo from "../assets/logoBalmacedaWhite.svg"

const CollapseSection = styled.div`
  .plus {
    width: 35px;
    height: 35px;
    position: relative;

    &:after,
    &:before {
      content: " ";
      position: absolute;
      display: block;
      background-color: black;
    }

    &:after {
      height: 3px;
      margin-top: -2px;
      top: 50%;
      left: 5px;
      right: 5px;
      z-index: 9;
    }
    &:before {
      width: 3px;
      margin-left: -2px;
      left: 50%;
      top: 5px;
      bottom: 5px;
      z-index: 9;
    }
  }
  .collapse {
    cursor: pointer;
    padding: 18px;
    align-items: center;
    border-top: 2px solid gray;
    outline: none;
    transition: background-color 0.6s ease;
  }

  .collapse__content {
    overflow: hidden;
    transition: 0.6s ease;
  }
  @media only screen and (min-device-width: 1366px) and (max-device-width: 1366px) and (orientation: landscape) {
    .plus::after {
      margin-top: -3px;
    }
    .plus::before {
      margin-left: -1px;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .plus::after {
      margin-top: -3px;
    }
    .plus::before {
      margin-left: -2px;
      z-index: 9;
    }
  }
  @media (min-width: 481px) and (max-width: 767px), {
    .plus::after {
      margin-top: -3px;
      z-index: 9;
    }
    .plus::before {
      margin-left: -2px;
    }
  }
  @media (min-width: 320px) and (max-width: 480px) {
    .plus::before {
      margin-left: -2px;
    }
  }
`

const StyledLink = styled(Box)`
  a {
    text-decoration: none;
    color: white;
  }
`

const RightLinks = styled(Box)`
  a {
    text-transform: uppercase;
  }
`

const Footer = ({ t }) => {
  const [show, setActiveState] = useState("")
  const [setHeight, setHeightState] = useState("0px")

  const content = useRef(null)

  const toggleForm = () => {
    setActiveState(show === "" ? "active" : "")
    setHeightState(
      show === "active" ? "0px" : `${content.current.scrollHeight}px`
    )
  }
  return (
    <div>
      <CollapseSection>
        <Flex
          flexDirection="row"
          onClick={() => toggleForm()}
          className={` collapse ${setActiveState}`}
          mx={[2, 4, 4]}
        >
          <Box width={3 / 4} className="collapse__section">
            <Text fontSize={[2, 3]} pl={[2, 2, 2]}>
              {t("footer.contact")}
            </Text>
          </Box>
          <Box
            width={1 / 4}
            justifyContent="flex-end"
            alignContent="flex-end"
            flexWrap="wrap-inverse"
            textAlign="left"
            ml={[220, 500, 800]}
          >
            <div className="plus" />
          </Box>
        </Flex>

        <div
          ref={content}
          style={{ maxHeight: `${setHeight}` }}
          className="collapse__content"
        >
          <Contact />
        </div>
      </CollapseSection>
      <Box
        color="white"
        as="footer"
        bg="black"
        pb={[3, 4]}
        width={[1]}
        px={[3, 5]}
      >
        <Flex flexDirection={["column", "row"]} alignItems="center">
          <Image src={logo} width={["200px", "250px"]} mt={[4, 5]} />
        </Flex>
        <StyledLink>
          <Flex flexWrap="wrap" flexDirection={["row", "row"]} pt={3}>
            <Box
              width={[1, 1 / 2]}
              textAlign={["center", "left"]}
              color="white"
              bg="primary"
              pb={3}
            >
              <Box width={[1]} pb={1}>
                <a href="tel:+5215518812741" mt={[1, 2, 3]} color="white">
                  T. + 52 1 55 1881 2741
                </a>
              </Box>
              <Box width={[1]}>
                <a
                  href="mailto:contacto@jmbalmaceda.com"
                  mt={[1, 2, 3]}
                  color="white"
                  width={[1]}
                >
                  contacto@jmbalmaceda.com
                </a>
              </Box>
            </Box>

            <RightLinks
              pb={3}
              width={[1, 1 / 2]}
              color="white"
              bg="secondary"
              textAlign={["center", "right"]}
            >
              <Flex
                flexWrap={["wrap", "wrap-reverse"]}
                flexDirection={["row", "column"]}
              >
                <Box width={[1]} px={[1]} fontSize={[1]}>
                  <Link to="/blog">{t("header.blog")}</Link>
                </Box>
              </Flex>
            </RightLinks>
          </Flex>
          <Flex flexDirection="row" textAlign="center">
            <Box
              pt={[3, 4, 5]}
              pb={[1, 1, 3]}
              width={(1, 1 / 2, 1)}
              color="white"
              bg="primary"
            >
              <Text
                fontSize={[0, 1]}
                sx={{ lineHeight: "1.5" }}
                as="p"
                color="white"
              >
                {t("footer.copy")}
              </Text>
            </Box>
          </Flex>
        </StyledLink>
      </Box>
    </div>
  )
}

Footer.propTypes = {
  t: propTypes.func.isRequired,
}

export default withTranslation(Footer)
